import { isFapiaoValid } from './fapiao';
import { formatUrl } from './payment-utils';
import { isSecondaryBlockOpened } from './payment';

export function BankListBlock() {

  this.init = function init(params) {
    this.parent = params.parent;
    this.container = params.container;
    this.onExpressConfirmation = params.onExpressConfirmation;
    this.header = this.container.querySelector('.dkt-block-header');
    this.content = this.container.querySelector('.dkt-block-content');
    this.bankRadio = this.container.querySelectorAll('[name=rb-bank]');
    this.message = this.container.querySelector('.dkt-block-message');

    this.props = {
      id: this.container.getAttribute('data-payment-type-id'),
      multiEnabled: this.container.getAttribute('data-multi-enabled'),
      orderId: params.orderId,
      isExpress: params.isExpress || false,
      isCheckout: params.isCheckout || false
    };

    this.state = {
      selected: params.selected || false
    };

    if (this.state.selected === true) {
      this.select();
    }

    this.events();
  };
}

BankListBlock.prototype.events = function events() {
  const $this = this;
  if (this.props.isExpress === false) {
    this.header.addEventListener('click', this.select.bind(this));
  }
  document.addEventListener('clickedOnPay', this.check.bind(this));
  document.addEventListener('PrimaryPaymentBlockSelected', this.unselect.bind(this));
  [].forEach.call(this.bankRadio, radio => {
    radio.addEventListener('change', () => {
      $this.hideMessage.bind($this);
      $this.selectedBank = radio.value;
    });
  });
};

BankListBlock.prototype.select = function select(event) {
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));

    $(this.content).slideDown('fast', this.displaySelected.bind(this));
    this.state.selected = true;
    if (this.props.isExpress === false) {
      this.parent.enableButton();
    }
  }
};

BankListBlock.prototype.displaySelected = function displaySelected() {
  this.container.classList.add('dkt-block--selected');
  this.container.classList.add('dkt-block--open');
};

BankListBlock.prototype.displayUnselected = function displayUnselected() {
  this.container.classList.remove('dkt-block--selected');
  this.container.classList.remove('dkt-block--open');
};

BankListBlock.prototype.unselect = function unselect() {
  $(this.content).slideUp('normal', this.displayUnselected.bind(this));
  this.state.selected = false;
};

BankListBlock.prototype.check = function check() {
  if (this.parent.checkTermsOfUse && this.parent.checkTermsOfUse() === false) {
    return;
  }

  if (this.props.isCheckout === true) {
    if (this.parent.checkBillingAddress && this.parent.checkBillingAddress() === false) {
      return;
    }
    if (this.parent.isFullSecondaryPayment && this.parent.isFullSecondaryPayment() === true) {
      return;
    }
    if (isFapiaoValid() === false) {
      return;
    }
  }

  if (this.state.selected === true) {
    if (this.selectedBank) {
      this.submitPayment();
    } else {
      this.displayMessage();
    }
  }
};

BankListBlock.prototype.displayMessage = function displayMessage() {
  this.message.classList.add('dkt-block-message--visible');
  this.message.parentNode.scrollIntoView();
};

BankListBlock.prototype.hideMessage = function hideMessage() {
  this.message.classList.remove('dkt-block-message--visible');
};

BankListBlock.prototype.submitPayment = function submitPayment() {
  if (document.getElementById('orderTrackingUrl') !== null) {
    this.props.orderTracking = document.getElementById('orderTrackingUrl').value;
  }

  if (document.getElementById('redirectionUrl') !== null) {
    this.props.redirectionUrl = document.getElementById('redirectionUrl').value;
  }

  const changePaymentMethodTag = cube.$id('change-payment-method');
  const changePaymentMethod = changePaymentMethodTag ? changePaymentMethodTag.value === 'true' : false;

  let params = {
    'changePaymentMethod': changePaymentMethod,
    orderId: this.props.orderId,
    paymentTypeId: this.props.id,
    redirectionUrl: this.props.redirectionUrl,
    useSecondaryMop: isSecondaryBlockOpened(),
    additionnalParameters: JSON.stringify({
      bank: this.selectedBank
    })
  };

  if (this.parent.addFapiaoParams) {
    params = this.parent.addFapiaoParams(params);
  }

  if (this.parent.getAnalyticsInfos) {
    params.orderAttributes = JSON.stringify(this.parent.getAnalyticsInfos());
  }

  this.parent.displayLoader();
  cube.ajax.post(formatUrl('applyPayment', params.orderId), params)
    .onSuccess(this.submitPaymentSuccess.bind(this))
    .call();
};

BankListBlock.prototype.submitPaymentSuccess = function submitPaymentSuccess(response) {
  if (response && response.result && response.result.data) {
    const data = response.result.data;
    if (window.cube.config.anly_useLegacy === 'Y') {
      CUBE.Analytics.queue.send('proceedToConfirmation');
    }

    if (data.paymentModifiable === 'false') {
      window.location.reload();
    }

    if (data.redirectConfirmation === 'true') {
      window.location.href = data.redirectionUrl;
    }

    if (data.paymentAction === 'REDIRECTION_DIRECT') {
      window.location.href = data.urlValidation;
    }

    if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
      this.onExpressConfirmation(data.redirectConfirmation);
    }

    if (data.redirectPspForm !== null) {
      const paymentRedirectForm = document.getElementById('payment-redirect-form');
      paymentRedirectForm.innerHTML = data.redirectPspForm;
      paymentRedirectForm.querySelector('form').submit();
    }
  } else {
    this.parent.hideLoader();
    if (this.parent.displayError) {
      this.parent.displayError(response.responseTO.errors[0].message);
    }
  }
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-banklist.js